/* eslint-disable max-lines */
/* eslint-disable prefer-object-spread */
/* eslint-disable react/prop-types */
import { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { Buffer } from 'buffer';
import { Box, Button, Grid, IconButton, LinearProgress, Link, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { DocChecklistStyles as classes } from './DocChecklistStyles';
import Vector from '../../../images/Vector.svg';
import SuccessCheck from '../../../images/Document_Tick.png';
import {
  generateFileMD5,
  uploadDocChecklist,
  uploadDocumentByPreSignedURL,
  uploadDocXLDocCheckilst,
} from '../../../services/uploadService';
import { CLICK_TO_UPLOAD } from '../../../constants';
import { DeleteIcon, FileIcon } from '../../../images/svg/CustomizedSVG';
import { LayoutStyles as bundleClasses } from '../../Bundle/LayoutStyles';

const BusinessDragDropUploadACT = ({ itemObj, personal }) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    uploadGlobalFiles,
    setUploadGlobalFiles,
    uploadGlobalStatus,
    setUploadGlobalStatus,
    uploadGlobalDocId,
    setUploadGlobalDocId,
    globalProgress,
    setGlobalProgress,
    modalMessageGlobal,
    setModalMessageGlobal,
    setOpenModalGlobal,
    setIsErrorGlobal,
    checklistErrGlobal,
    setChecklistErrGlobal,
    cancelBAupload,
    cancelBOAupload,
    currentPage,
    cancelActupload,
    cancelAtmupload,
    setIsGlobalFileUploadingAll,
    savedSuriDocs,
    savedBusinessDocs,
  } = leadGenerationContext;
  const wrapperRef = useRef(null);

  useEffect(() => {
    const types = ['atm', 'act', 'act22'];
    for (const type of types) {
      if (!uploadGlobalFiles[type]) {
        setUploadGlobalDocId((prevState) => ({
          ...prevState,
          [type]: '',
        }));
      }
    }
  }, [
    uploadGlobalDocId?.act,
    uploadGlobalStatus?.act,
    uploadGlobalDocId?.atm,
    uploadGlobalStatus?.atm,
    uploadGlobalStatus?.act22,
    uploadGlobalDocId?.act22,
  ]);

  const onKeyEnterCancel = (e) => {
    if (e.key === 'Enter') {
      handleCancel(e);
    }
  };
  const handleCancel = (e) => {
    if (e.target.name === 'businessAddress') {
      cancelBAupload?.source?.cancel();
    } else if (e.target.name === 'businessOwnerAddress') {
      cancelBOAupload?.source?.cancel();
    } else if (e.target.name === 'act') {
      cancelActupload?.source?.cancel();
    } else if (e.target.name === 'atm') {
      cancelAtmupload?.source?.cancel();
    } else if (e.target.name === 'act22') {
      leadGenerationContext.cancelAct22upload?.source?.cancel();
    } else if (e.target.name === 'emancipationevidence') {
      leadGenerationContext.cancelEmancipationEvidence?.source?.cancel();
    }
    if (currentPage === 'business-suri') {
      leadGenerationContext.setIsBusinessSuriDirty(true);
      leadGenerationContext.setIsBusinessAccountInfoDirty(true);
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    } else if (currentPage === 'business-comp') {
      leadGenerationContext.setIsBusinessCompDirty(true);
      leadGenerationContext.setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    } else if (currentPage === 'compliance-info') {
      leadGenerationContext.setIsScreenFourDirty(true);
      leadGenerationContext.setIsScreenFiveDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
    }

    setUploadGlobalFiles({ ...uploadGlobalFiles, [e.target.name]: '' });
    setUploadGlobalDocId((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setUploadGlobalStatus((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setGlobalProgress((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  };
  const preSignedUrlResponse = (resp, documentId, _typeName) => {
    if (resp && resp.status === 200) {
      setUploadGlobalDocId((prevState) => ({
        ...prevState,
        [_typeName]: documentId,
      }));
      setUploadGlobalStatus((st) => ({
        ...st,
        [_typeName]: 'success',
      }));
      setIsGlobalFileUploadingAll((disb) => ({
        ...disb,
        [_typeName]: false,
      }));

      if (currentPage === 'business-suri') {
        leadGenerationContext.setIsBusinessSuriDirty(true);
        leadGenerationContext.setIsBusinessAccountInfoDirty(true);
        leadGenerationContext.setIsBusinessCompDirty(true);
        leadGenerationContext.setIsDocChecklistDirty(true);
        leadGenerationContext.setIsCommercialProductUIDirty(true);
      } else if (currentPage === 'business-comp') {
        leadGenerationContext.setIsBusinessCompDirty(true);
        leadGenerationContext.setIsDocChecklistDirty(true);
        leadGenerationContext.setIsCommercialProductUIDirty(true);
      } else if (currentPage === 'compliance-info') {
        leadGenerationContext.setIsScreenFourDirty(true);
        leadGenerationContext.setIsScreenFiveDirty(true);
        leadGenerationContext.setIsFundingScreenDirty(true);
      }

      setChecklistErrGlobal((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: '',
        })
      );
    } else {
      setIsGlobalFileUploadingAll((disb) => ({
        ...disb,
        [_typeName]: false,
      }));
      setUploadGlobalStatus((prevState) => ({
        ...prevState,
        [_typeName]: 'failed',
      }));

      // err check
      setIsErrorGlobal(false);
      setChecklistErrGlobal((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: 'Click to upload again.',
        })
      );
    }
  };
  const documentResponse = async (
    fileMD5,
    fileExtension,
    fileName,
    fileType,
    fileSize,
    file,
    typeName
  ) => {
    const fileMd5Base64 = Buffer.from(fileMD5, 'hex').toString('base64');
    const response = await uploadDocXLDocCheckilst(
      fileExtension,
      fileName,
      fileType,
      fileSize,
      fileMd5Base64,
      leadGenerationContext.accessToken,
      typeName,
      setGlobalProgress,
      leadGenerationContext
    );
    if (response?.data) {
      const documentId = response.data.documentId ? response.data.documentId : null;
      const preSignedUrl = response.data.preSignedUrl ? response.data.preSignedUrl : null;
      if (preSignedUrl && documentId) {
        const resp = await uploadDocumentByPreSignedURL(
          preSignedUrl,
          file,
          fileMd5Base64,
          leadGenerationContext.setStatementUploadProgress,
          leadGenerationContext.setStatementLinearProgress
        );
        preSignedUrlResponse(resp, documentId, typeName);
      } else {
        setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
        setUploadGlobalStatus((prevState) =>
          Object.assign({}, prevState, { [typeName]: 'failed' })
        );
        // err check
        setIsErrorGlobal(false);
        setChecklistErrGlobal((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: 'Click to upload again.',
          })
        );
      }
    } else {
      setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
      setUploadGlobalStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setIsErrorGlobal(false);
      // err check
      setChecklistErrGlobal((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Click to upload again.',
        })
      );
    }
  };
  //
  const onDrop = (e, fileType) => {
    e.preventDefault();
    const fileNameOnDrop = e.target.name;
    setUploadGlobalStatus((prevState) => Object.assign({}, prevState, { [fileNameOnDrop]: '' }));
    const file = e.dataTransfer.files[0];
    setUploadGlobalFiles({ ...uploadGlobalFiles, [fileNameOnDrop]: file });
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const onFileDrop = (e, fileType) => {
    e.preventDefault();
    setUploadGlobalStatus((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    const file = e.target.files[0];
    setUploadGlobalFiles({ ...uploadGlobalFiles, [e.target.name]: file });
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const setWrapperRefValue = () => {
    if (wrapperRef?.current?.value) {
      wrapperRef.current.value = '';
    }
  };
  const Md5Check = async (fileMD5, fileExtension, fileName, fileType, fileSize, file, typeName) => {
    if (fileMD5) {
      await documentResponse(fileMD5, fileExtension, fileName, fileType, fileSize, file, typeName);
    } else {
      setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
      setUploadGlobalStatus((prev) => Object.assign({}, prev, { [typeName]: 'failed' }));
      // err check
      setIsErrorGlobal(false);
      setChecklistErrGlobal((p) =>
        Object.assign({}, p, {
          [typeName]: CLICK_TO_UPLOAD,
        })
      );
    }
  };

  const uploadFile = async (file, e, fileType) => {
    setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [e.target.name]: true }));
    const fileName = file.name;
    const fileParts = fileName.split('.');
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase();
    const fileSize = file.size;
    const typeName = e.target.name;
    if (fileSize > 10485760) {
      setWrapperRefValue();
      setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
      setUploadGlobalStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setModalMessageGlobal({
        ...modalMessageGlobal,
        messageTitle: 'Document uploaded is not supported.',
        messageSubTitle: 'The file exceeds the maximum upload size (10 Mb).',
        typeName: e.target.name,
      });
      setOpenModalGlobal(true);
      setIsErrorGlobal(true);

      setChecklistErrGlobal((prev) =>
        Object.assign({}, prev, {
          [typeName]: 'The file exceeds the maximum upload size (10 Mb).',
        })
      );
      return;
    }
    const extensions = ['pdf', 'jpg', 'jpeg', 'png'];
    let isValidExtension = false;
    if (extensions.includes(fileExtension.toLowerCase())) isValidExtension = true;
    if (!isValidExtension) {
      setWrapperRefValue();
      setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
      setUploadGlobalStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setModalMessageGlobal({
        ...modalMessageGlobal,
        messageTitle: 'Document uploaded is not supported.',
        messageSubTitle: 'Only files with the following formats are allowed: PNG, JPG, PDF.',
        typeName: e.target.name,
      });
      setOpenModalGlobal(true);
      setIsErrorGlobal(true);

      setChecklistErrGlobal((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Only files with the following formats are allowed: PNG, JPG, PDF.',
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    if (fileSize > 3145728) {
      const fileMD5 = await generateFileMD5(file);
      Md5Check(fileMD5, fileExtension, fileName, fileType, fileSize, file, typeName);
    } else {
      const response = await uploadDocChecklist(
        fileExtension,
        fileName,
        fileType,
        formData,
        leadGenerationContext.accessToken,
        typeName,
        setGlobalProgress,
        leadGenerationContext
      );

      if (response?.data) {
        setUploadGlobalDocId((prevState) =>
          Object.assign({}, prevState, { [typeName]: response.data.documentId })
        );
        setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
        setUploadGlobalStatus((prevState) =>
          Object.assign({}, prevState, { [typeName]: 'success' })
        );
        if (currentPage === 'business-suri') {
          leadGenerationContext.setIsBusinessSuriDirty(true);
          leadGenerationContext.setIsBusinessAccountInfoDirty(true);
          leadGenerationContext.setIsBusinessCompDirty(true);
          leadGenerationContext.setIsDocChecklistDirty(true);
          leadGenerationContext.setIsCommercialProductUIDirty(true);
        } else if (currentPage === 'business-comp') {
          leadGenerationContext.setIsBusinessCompDirty(true);
          leadGenerationContext.setIsDocChecklistDirty(true);
          leadGenerationContext.setIsCommercialProductUIDirty(true);
        } else if (currentPage === 'compliance-info') {
          leadGenerationContext.setIsScreenFourDirty(true);
          leadGenerationContext.setIsScreenFiveDirty(true);
          leadGenerationContext.setIsFundingScreenDirty(true);
        }
        setIsErrorGlobal(false);

        setChecklistErrGlobal((ps) =>
          Object.assign({}, ps, {
            [typeName]: '',
          })
        );
      } else {
        setIsGlobalFileUploadingAll((disb) => Object.assign({}, disb, { [typeName]: false }));
        setUploadGlobalStatus((p) => Object.assign({}, p, { [typeName]: 'failed' }));
        // err check
        setIsErrorGlobal(false);
        setChecklistErrGlobal((pst) =>
          Object.assign({}, pst, {
            [typeName]: CLICK_TO_UPLOAD,
          })
        );
      }
    }
  };

  let docType = '';
  const businessDocumentUpload = (fileItem) => {
    const businessCompdocLabels = [
      {
        name: 'atm',
        label: '(Upload ATM Rental or Purchase Documentation)',
      },
      {
        name: 'act',
        label: '(Upload your ACT 20 Certification)',
      },
    ];
    for (const item in savedBusinessDocs) {
      if (savedBusinessDocs[item].type && savedBusinessDocs[item].preSignedUrl) {
        for (const label in businessCompdocLabels) {
          if (
            businessCompdocLabels[label].name === fileItem.name &&
            businessCompdocLabels[label].label === savedBusinessDocs[item].type
          ) {
            docType = savedBusinessDocs[item].preSignedUrl;
            break;
          }
        }
      }
    }
  };

  const getFilePreview = (fileItem) => {
    const docLabels = [
      {
        name: 'businessAddress',
        label: 'Upload Address Proof',
        //   id: 1,
      },
      {
        name: 'businessOwnerAddress',
        label: 'Upload Owner Address Proof',
        //   id: 1,
      },
    ];

    for (const item in savedSuriDocs) {
      if (savedSuriDocs[item].type && savedSuriDocs[item].preSignedUrl) {
        for (const label in docLabels) {
          if (
            docLabels[label].name === fileItem.name &&
            docLabels[label].label === savedSuriDocs[item].type
          ) {
            docType = savedSuriDocs[item].preSignedUrl;
            break;
          }
        }
      }
    }
    businessDocumentUpload(fileItem);
    if (uploadGlobalFiles[fileItem.name]?.type) {
      return URL.createObjectURL(uploadGlobalFiles[fileItem.name]);
    }
    return docType;
  };
  const commonTernary = (condition, result1, result2) => {
    if (condition) {
      return result1;
    }
    return result2;
  };
  return (
    // eslint-disable-next-line jsx-a11y/aria-role
    <Box component="div" key={itemObj.id} sx={classes.gridItem} role="section">
      <div>
        <Box component="div" sx={classes.labelCheckContainer}>
          <Typography
            sx={
              itemObj.name === 'act' || itemObj.name === 'atm'
                ? classes.toggle_Label_Style
                : classes.businessType
            }
          >
            {t(itemObj.label, { defaultValue: itemObj.label })}
          </Typography>
          {uploadGlobalStatus[itemObj.name] === 'success' && (
            <img
              src={SuccessCheck}
              alt="success icon"
              name={itemObj.name}
              height="16px"
              width="16px"
              style={{ marginLeft: '5px' }}
            />
          )}
        </Box>
        {/* main draggable container */}
        {!uploadGlobalFiles[itemObj.name]?.name || uploadGlobalStatus[itemObj.name] === 'failed' ? (
          <>
            <Box
              component="div"
              aria-roledescription={`Drag and drop or Choose File ${itemObj.label}`}
              sx={[
                commonTernary(
                  uploadGlobalStatus[itemObj.name] === 'failed',
                  classes.uploadContainerError,
                  classes.uploadContainer
                ),
                commonTernary(personal, classes.box_new_design, classes.box),
                commonTernary(
                  uploadGlobalStatus[itemObj.name] === 'failed',
                  classes.box_a_Error,
                  commonTernary(personal, classes.box_a_new_design, classes.box_a)
                ),
                uploadGlobalStatus[itemObj.name] === 'failed' && classes.error,
              ]}
              className="drop-file-input"
              id={itemObj.name}
            >
              <Box component="span" sx={classes.dragDropText}>
                <Box
                  component="input"
                  type="file"
                  tabIndex="-1"
                  name={itemObj.name}
                  aria-label={` ${t(itemObj.label)}`}
                  accept=".pdf,.jpg,.jpeg,.png"
                  sx={classes.fileInput}
                  onChange={(e) => onFileDrop(e, itemObj.label)}
                  data-testid={`file_change_${itemObj.name}`}
                  ref={wrapperRef}
                  onDrop={(e) => onDrop(e, itemObj.label)}
                />

                {!isMobile && (
                  <Box component="span" sx={classes.dragContent}>
                    {t('Drag and drop or ', { defaultValue: 'Drag and drop or ' })}
                  </Box>
                )}
                <Box component="span" sx={classes.chooseFile}>
                  {t('Choose file', { defaultValue: 'Choose file' })}
                </Box>
              </Box>
            </Box>
            {uploadGlobalStatus[itemObj.name] === 'failed' &&
              checklistErrGlobal[itemObj.name] === CLICK_TO_UPLOAD && (
                <span
                  role="alert"
                  style={{
                    color: 'red',
                    margin: '2px',
                    display: 'block',
                    fontSize: '14px',
                  }}
                  data-testid="document-upload-error"
                >
                  {t(checklistErrGlobal[itemObj.name], {
                    defaultValue: checklistErrGlobal[itemObj.name],
                    nsSeparator: '|',
                  })}
                </span>
              )}
          </>
        ) : (
          <div>
            <Box component="div" sx={classes.displayUploaded}>
              {commonTernary(
                uploadGlobalStatus[itemObj.name] === '',
                <Typography style={{ wordBreak: 'break-all', paddingRight: '5px' }}>
                  {uploadGlobalFiles[itemObj.name]?.name}
                </Typography>,
                <Link
                  style={{ wordBreak: 'break-all', paddingRight: '5px' }}
                  sx={classes.uploadedFileName}
                  href={getFilePreview(itemObj)}
                  target="_blank"
                >
                  {uploadGlobalFiles[itemObj.name]?.name}
                </Link>
              )}
              <Box component="span" sx={classes.cancelIcon}>
                <IconButton
                  id="closeIconId"
                  name={itemObj.name}
                  data-testid={`cancel_testid_${itemObj.name}`}
                  onClick={handleCancel}
                  onKeyDown={onKeyEnterCancel}
                  size="small"
                  color="inherit"
                >
                  <img
                    src={Vector}
                    alt={t('cancel icon', { defaultValue: 'cancel icon' })}
                    name={itemObj.name}
                    height="12px"
                    width="12px"
                  />
                </IconButton>
              </Box>
            </Box>

            {!uploadGlobalStatus[itemObj.name] && (
              <LinearProgress
                variant="determinate"
                value={globalProgress[itemObj.name]}
                classes={{
                  barColorPrimary: classes.progressColor,
                  root: classes.linearBar,
                }}
              />
            )}
          </div>
        )}
        <Box component="div" sx={classes.supported_text}>
          <Box
            component="div"
            sx={
              checklistErrGlobal[itemObj.name] &&
              checklistErrGlobal[itemObj.name] !== CLICK_TO_UPLOAD
                ? classes.file_size_Error
                : commonTernary(personal, classes.file_size_newDesign, classes.file_size)
            }
            style={{ paddingRight: '10px' }}
          >
            {' '}
            {t('Supported file types: PNG, JPG, PDF.', {
              defaultValue: 'Supported file types: PNG, JPG, PDF.',
              nsSeparator: '|',
            })}
          </Box>
          <Box
            component="div"
            sx={
              checklistErrGlobal[itemObj.name] &&
              checklistErrGlobal[itemObj.name] !== CLICK_TO_UPLOAD
                ? classes.file_size_Error
                : commonTernary(personal, classes.file_size_newDesign, classes.file_size)
            }
            style={{ paddingLeft: '10px' }}
          >
            {' '}
            {t('Maximum: 10MB', {
              defaultValue: 'Maximum: 10MB',
              nsSeparator: '|',
            })}
          </Box>
        </Box>
      </div>
    </Box>
  );
};
BusinessDragDropUploadACT.propTypes = {
  itemObj: PropTypes.object.isRequired,
  personal: PropTypes.bool,
};

BusinessDragDropUploadACT.defaultProps = {
  personal: false,
};
export default BusinessDragDropUploadACT;
